export default "__VITE_ASSET__DsWz5td1__"